import { Button, Drawer, Form, Input, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const AddCategory = ({
  open,
  close,
  setLoading,
  getProductCategory,
  limit,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);

  const handleCreateCategory = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("limit", limit);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/new-product-category", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "exceed-limit") {
          rerunNotif("error", "Exceed limit.");
          setTimeout(() => {
            setLoadings(false);
            setLoading(false);
          }, 1000);
        }
        if (data === "success") {
          rerunNotif("success", "Created new product category successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getProductCategory();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Create Product Category"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-category"
        initialValues={{ remember: true }}
        onFinish={handleCreateCategory}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="category"
            label="Category"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set category" size="large" />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddCategory;
